//宏创控股
import Overview from './overview.vue';
import Full from './FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 